<template>
    <div id="contendor-principal-cedulasEnviadas">
         <div id="contenedor-encabezados-cedulasEnviadas" class="text-left">
            <h1>CEDULAS ENVIADAS</h1>
            <h3>Ingrese la información para ver la lista de las cedulas enviadas por juzgado o por area de notificacion</h3>
        </div>
        <div id="contendor-cedulasEnviadas" class="padding-div-low">
            <div class="area col-11">
                <h5>Registros de cedulas enviadas</h5>
                <hr />
                <div id="contenedor-cedulasEnviadas-campos" class="contenedor-color-negro">
                    <div id="contenedor-opciones-busqueda" style="display: flex; justify-content: flex-end; margin-top: 1em;">
                        <div style="display: flex; align-items: center; margin-right: 1em;">
                            <h6 style="margin-right: 1em;">Buscar por:</h6>
                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                <label :class="[porAreaNotificacion ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="porAreaNotificacion = true, porJuzgado = false">
                                    <input type="radio" name="options" id="radioConCatalogo" autocomplete="off"  checked>Area de notificacion
                                </label>
                                <label :class="[porJuzgado ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="porJuzgado = true, porAreaNotificacion = false">
                                    <input type="radio" name="options" id="radioConFormulario" autocomplete="off" >Juzgado
                                </label>
                            </div>
                        </div>
                        <button type="button" id="btn-datos-plantilla" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Cargar cedulas</button>
                    </div>
                    <div id="contenedor-filtros-cedulasEnviadas">
                        <div v-if="porAreaNotificacion" style=" margin-right: 1em; width: 33%;">
                            <h6>Direccion que notifica</h6>
                            <!-- Reemplazar por catalo verdadero -->
                            <select id="CDireccion-tipoPersona"  v-model="direccionQueNotifica" class="form-control">
                                <option value="-1">Seleccione una direccion</option>
                                <option value="direccion1">direccion 1</option>
                                <option value="direccion2">direccion 2</option>
                            </select> 
                        </div>
                        <div v-if="porJuzgado" style=" margin-right: 1em; width: 33%;">
                            <h6>Juzgado</h6>
                            <!-- Reemplazar por catalo verdadero -->
                            <select id="CDireccion-tipoPersona"  v-model="juzgado" class="form-control">
                                <option value="-1">Seleccione un juzgado</option>
                                <option value="juzgado1">juzgado 1</option>
                                <option value="juzgado2">juzgado 2</option>
                            </select> 
                        </div>
                        <div style=" margin-right: 1em; width: 33%;">
                            <h6>Fecha inicial</h6>
                            <input type="date" id="fechaFinal" v-model="fechaInicial" class="form-control" />
                        </div>
                        <div style="width: 33%;">
                            <h6>Fecha final</h6>
                            <input type="date" id="fechaFinal" v-model="fechaFinal" class="form-control" />
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div id="titulo-tabla">
                            <h4>CEDULAS ENCONTRADAS</h4>
                        </div>
                        <CTablaGenericaCedulas 
                            :idDelInput="ID_TABLA_CEDULAS_ENCONTRADAS"
                            :encabezadosColumnas="encabezadosColumnas"
                            :accionesEnTabla="this.TABLA_CEDULAS_SELECCIONADA_ACCIONES"
                            v-on:accionesFuncionDeVer="mostrarReporte"
                            :listaDeCedulas="listaDeCedulas"></CTablaGenericaCedulas>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import router from '@/router/index'

export default {
    components: {
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            ID_TABLA_CEDULAS_ENCONTRADAS: 'tablaCedulasEnviadasHistorial',
            encabezadosColumnas: ['Folio','Tipo de documento','Tipo de cedula','Estatus',''],
            TABLA_CEDULAS_SELECCIONADA_ACCIONES: {motrarAcciones: true,check: false, eliminar: false, imprimir: true, ver: true},
            listaDeCedulas: [
                {Folio: 1,tipoDeDocumento: 'cedula',tipoDeCedula:'001',estatus:'Realizada'},
                {Folio: 2,tipoDeDocumento: 'cedula 1',tipoDeCedula:'002',estatus:'Realizada'},
                {Folio: 3,tipoDeDocumento: 'cedula 2',tipoDeCedula:'003',estatus:'Realizada'},
                {Folio: 4,tipoDeDocumento: 'cedula 3',tipoDeCedula:'004',estatus:'Realizada'},
                {Folio: 5,tipoDeDocumento: 'cedula 4',tipoDeCedula:'004',estatus:'Realizada'},
                {Folio: 6,tipoDeDocumento: 'cedula 5',tipoDeCedula:'001',estatus:'Realizada'},
                {Folio: 7,tipoDeDocumento: 'cedula 6',tipoDeCedula:'002',estatus:'Realizada'},
                {Folio: 8,tipoDeDocumento: 'cedula 7',tipoDeCedula:'003',estatus:'Realizada'},
                {Folio: 9,tipoDeDocumento: 'cedula 8',tipoDeCedula:'004',estatus:'Realizada'},
                {Folio: 10,tipoDeDocumento: 'cedula 9',tipoDeCedula:'004',estatus:'Realizada'},
                {Folio: 11,tipoDeDocumento: 'cedula 10',tipoDeCedula:'001',estatus:'Realizada'},
                {Folio: 12,tipoDeDocumento: 'cedula 11',tipoDeCedula:'002',estatus:'Realizada'},
                {Folio: 13,tipoDeDocumento: 'cedula 12',tipoDeCedula:'003',estatus:'Realizada'},
                {Folio: 14,tipoDeDocumento: 'cedula 13',tipoDeCedula:'004',estatus:'Realizada'},
                {Folio: 15,tipoDeDocumento: 'cedula 14',tipoDeCedula:'004',estatus:'Realizada'}
            ],
            porAreaNotificacion: true,
            porJuzgado: false,
            direccionQueNotifica: -1,
            juzgado: -1,
            fechaFinal: null,
            fechaInicial: null
        }
    },
    methods: {
       mostrarReporte: function() {
            router.push({ name: "ReporteEnvioDeCedulas", params: { idReporte: 1 } }) 
       }
    }
}
</script>
<style scoped>

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#contenedor-filtros-cedulasEnviadas {
    display: flex;
    align-items: center;
    margin-top: 2em;
}

#titulo-tabla {
    background-color: #1b1919;
    margin-top:2em;
    padding: 10px;
    margin-bottom: 0px;
}

#contendor-cedulasEnviadas {
    display: flex;
    justify-content: center;
}

.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}
.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

.btn-primary {
    color: white;
    background-color: rgb(36, 34, 34);
    border-color: white;
}

.btn-primary:hover {
    color: white;
    background-color: black;
    border-color: white;
}

.btn-primary:focus {
    color: white;
    background-color: black;
    border-color: white;
    box-shadow: none;;
}

.modal-lg {
    max-width: 80% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/EnvioAJuzgado/CCedulasEnviadas.vue